// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_by-0";
export var orangeButton = "_by-1";